import EventBus from "./event-bus";
import axios from "axios";


export function getAdminMerchants() {
  return new Promise(function(resolve, reject) {
    console.log("place order " + localStorage.getItem("JSTOKEN"));
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/merchants', {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        if(error.response != undefined && error.response.data != undefined && error.response.data.status != undefined && error.response.data.status == 403) {
          EventBus.$emit("sessionExpired");
        }
        reject(error);
      });
  })
}
export function changeAdminDriverChecked(id, check) {
  return new Promise(function(resolve, reject) {
    console.log("place order " + localStorage.getItem("JSTOKEN"));
    EventBus.$emit("showLoading", true);
    axios.get(process.env.ROOT_API + 'admin/driver/order/item/' + id + '/validate?check=' + check, {
      headers:{
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response['data'];
      console.log(data);
      resolve(data);
    })
      .catch(error=>{
        EventBus.$emit("showLoading", false);
        console.log("error to update");
        console.log(error.response);
        if(error.response != undefined && error.response.data != undefined && error.response.data.status != undefined && error.response.data.status == 403) {
          EventBus.$emit("sessionExpired");
        }
        reject(error);
      });
  })
}



// WEBPACK FOOTER //
// ./src/api/admin.js